var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"25","height":"26","viewBox":"0 0 25 26","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M11.0264 0.708984L15.5119 8.92102L24.5 7.68582L19.7043 15.2599L23.7115 25.2048L14.0641 20.3998L5.83429 25.3406L7.3079 16.5901L0.5 11.6448L8.58761 9.99786L11.0264 0.708984Z","fill":"#CD001A"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }